var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"sheetLinks"},_vm._l((_vm.sheetLinks()),function(item){return _c('li',{key:item.name},[_c('a',{ref:"noreferrer",refInFor:true,attrs:{"href":item.link,"target":"_blank"}},[_vm._v(_vm._s(item.text))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }